import useAxiosService from './useAxiosService'
import { EStatus } from 'enums'
import { ISearchQuery } from 'interfaces'
import { IResponse } from 'interfaces/services'
import { SEARCH_TEMPLATE_QUERY_DEFAULT } from 'pages/accountSystemSetting/constants'
import {
  ICreateUpdateTemplateExam,
  IDataSearchTemplate,
  IQuerySearchTemplate,
  ITemplateExam
} from 'pages/accountSystemSetting/interfaces'

const useSystemSettingService = () => {
  const { post, get, patch, dele } = useAxiosService()

  const createTemplateExam = async (query: ICreateUpdateTemplateExam) => {
    const response: any = await post(`/clinic/examination-templates/`, query)
    return response as IResponse<ITemplateExam>
  }

  const searchTemplateExam = async (
    querySearch: ISearchQuery<IQuerySearchTemplate>
  ) => {
    const response: any = await post(
      `/clinic/examination-templates/search`,
      querySearch
    )
    return response as IResponse<IDataSearchTemplate>
  }

  const searchTemplateActiveWithMajor = async (majorId: number) => {
    const query = {
      ...SEARCH_TEMPLATE_QUERY_DEFAULT,
      query: {
        statues: [EStatus.Active],
        major_id: majorId
      }
    }
    const response: any = await post(
      `/clinic/examination-templates/search`,
      query
    )
    return response as IResponse<IDataSearchTemplate>
  }

  const searchTemplateDefaultActiveWithMajor = async (majorId: number) => {
    const query = {
      ...SEARCH_TEMPLATE_QUERY_DEFAULT,
      query: {
        statues: [EStatus.Active],
        major_id: majorId
      }
    }
    const response: any = await post(
      `/clinic/examination-templates/search`,
      query
    )
    return response as IResponse<IDataSearchTemplate>
  }

  const getTemplateExam = async (id: number | string) => {
    const response: any = await get(`/clinic/examination-templates/${id}`)
    return response as IResponse<ITemplateExam>
  }

  const deleteTemplateExam = async (id: number) => {
    const response: any = await dele(`/clinic/examination-templates/${id}`)
    return response as IResponse<ITemplateExam>
  }

  const updateTemplateExam = async (query: ICreateUpdateTemplateExam) => {
    const response: any = await patch(
      `clinic/examination-templates/${query.id}`,
      query
    )
    return response as IResponse<ITemplateExam>
  }

  return {
    createTemplateExam,
    searchTemplateExam,
    getTemplateExam,
    updateTemplateExam,
    deleteTemplateExam,
    searchTemplateActiveWithMajor,
    searchTemplateDefaultActiveWithMajor
  }
}

export default useSystemSettingService
